import React from 'react';

import { FeatureFlags } from './FeatureFlags';

export const defaultFeatureFlags: FeatureFlags = {
  metricsDataCatalogEnabled: true,
  writableFieldDescriptionsEnabled: true,
  fieldDescriptionInheritanceLineageEnabled: true,
  publishedConnectionsLineageEnabled: true,
  databasesInProjectsEnabled: true,
  lensLineageEnabled: true,
  relevantAssetsEnabled: false,
  mixedContentConnectToDialogEnabled: false,
  customSensitivityLabelsEnabled: false,
  searchAndFilterOnLineagePageEnabled: true,
};

export const FeatureFlagsContext = React.createContext<FeatureFlags>(
  defaultFeatureFlags
);

export function defaultFeatureFlagsWithOverrides(
  overrides: Partial<FeatureFlags>
): FeatureFlags {
  return {
    ...defaultFeatureFlags,
    ...overrides,
  };
}
